module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Avengers-Infinity-Wars.329a228.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Avengers-Infinity-Wars.jpg
// module id = h+BE
// module chunks = 0